// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"c9667ce2","455":"22f02ffa","488":"8d0dcc7f","977":"aac7d258"}[chunkId] + ".chunk.js";
};